/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';
import { JourneysSearchJourneyPost429Response } from '../model/journeysSearchJourneyPost429Response';
import { PostAddCompanionRequest } from '../model/postAddCompanionRequest';
import { PostAddCompanionResponse } from '../model/postAddCompanionResponse';
import { PostBoardingPassesGetWalletRequest } from '../model/postBoardingPassesGetWalletRequest';
import { PostBoardingPassesGetWalletResponse } from '../model/postBoardingPassesGetWalletResponse';
import { PostBoardingPassesIssueHpbpRequest } from '../model/postBoardingPassesIssueHpbpRequest';
import { PostBoardingPassesIssueHpbpResponse } from '../model/postBoardingPassesIssueHpbpResponse';
import { PostBoardingPassesSendMbpRequest } from '../model/postBoardingPassesSendMbpRequest';
import { PostCheckinCancelRequest } from '../model/postCheckinCancelRequest';
import { PostCheckinCancelResponse } from '../model/postCheckinCancelResponse';
import { PostCheckinConfirmRequest } from '../model/postCheckinConfirmRequest';
import { PostCheckinConfirmResponse } from '../model/postCheckinConfirmResponse';
import { PostCheckinTravelersRequest } from '../model/postCheckinTravelersRequest';
import { PostDeleteCompanionRequest } from '../model/postDeleteCompanionRequest';
import { PostFlightsSearchFlightsRequest } from '../model/postFlightsSearchFlightsRequest';
import { PostFlightsSearchFlightsResponse } from '../model/postFlightsSearchFlightsResponse';
import { PostJourneysGetJourneyRequest } from '../model/postJourneysGetJourneyRequest';
import { PostJourneysGetJourneyResponse } from '../model/postJourneysGetJourneyResponse';
import { PostJourneysSearchJourneyRequest } from '../model/postJourneysSearchJourneyRequest';
import { PostJourneysSearchJourneyResponse } from '../model/postJourneysSearchJourneyResponse';
import { PostSeatmapRequest } from '../model/postSeatmapRequest';
import { PostSeatmapResponse } from '../model/postSeatmapResponse';
import { PostServicesRequest } from '../model/postServicesRequest';
import { PostStandbyCancelRequest } from '../model/postStandbyCancelRequest';
import { PostStandbyCompleteEntryRequest } from '../model/postStandbyCompleteEntryRequest';
import { PostStandbyGetAlternativeOffersRequest } from '../model/postStandbyGetAlternativeOffersRequest';
import { PostStandbyGetAlternativeOffersResponse } from '../model/postStandbyGetAlternativeOffersResponse';
import { PostStandbySelectRequest } from '../model/postStandbySelectRequest';
import { PostTravelersStandByTravelersRequest } from '../model/postTravelersStandByTravelersRequest';
import { PostTravelersStandByTravelersResponse } from '../model/postTravelersStandByTravelersResponse';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class DefaultService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1. 概要 処理名： チェックイン取り消し&lt;br&gt; リクエストから受け取ったjourneyIDをDxAPIに渡し、最新のCPR情報を取得する。&lt;br&gt; リクエストから受け取ったチェックイン取り消し対象セグメント及び最新のCPR情報から、チェクイン取り消し可否判定を行い、判定結果が可の場合はチェックイン取り消しを行う。&lt;br&gt;  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにDxAPIを呼び出し、最新のCPR情報を取得する。&lt;br&gt; DxAPIのレスポンスの結果がエラー、検索結果が0件の場合、HTTPステータス400を返却する。  1. 取得したCPR情報をもとに、搭乗者毎、またはセグメント毎にチェックイン取り消し可否判定を行う。&lt;br&gt; 下記いずれかの条件に合致した場合、チェックイン取り消し不可とし、不可理由に対応するメッセージIDをレスポンス項目として設定し、HTTPステータスコード400を返却する。&lt;br&gt; いずれにも合致しなかった場合、チェックイン取り消し可とする。&lt;br&gt;   |No|条件|  |---:|:---|  |1|チェックイン取り消し対象セグメントの後続にチェックイン済セグメントが存在し、チェックイン取り消し対象になっていない|  |2|搭乗ゲート通過済み|  |3|手荷物が預け入れ済み|  |4|1便目の受付ステータスがopenedでないかつ後続のセグメントが存在しない|  |5|2便目以降かつ受付ステータスがopenedでない、かつ直前の便が出発済であるセグメントが存在する|  1. チェックイン取り消し対象の選択状況に応じてチェックイン取り消しを行う。&lt;br&gt;   1. Journeyに含まれるチェックイン済みセグメントすべてをチェックイン取り消し対象とする場合&lt;br&gt;   journeyIDをDxAPIに渡してチェックイン取り消しを搭乗者毎に行う。&lt;br&gt;     1. チェックイン取り消しが成功の場合、HTTPステータス204を返却する。&lt;br&gt;     1. チェックイン取り消しに予期せぬエラーが発生した場合、HTTPステータス500を返却する。&lt;br&gt;   1. Journeyに含まれるチェックイン済みセグメントをチェックイン取り消し対象として全て選択していない場合&lt;br&gt;   チェックイン取り消し対象セグメントを降順に並べ、journeyElementIDをDxAPIに渡してチェックイン取り消しを搭乗者毎に行う。&lt;br&gt;     1. すべてのjourneyElementIDでチェックイン取り消しが成功した場合、HTTPステータス204を返却する。&lt;br&gt;     1. 一部のjourneyElementIDでチェックイン取り消しが成功した場合、HTTPステータス200でワーニングを返却する。&lt;br&gt;     1. すべてのjourneyElementIDでチェックイン取り消し予期せぬエラーが発生した場合、HTTPステータス500を返却する。  # 3. データ更新内容 1. CPR  |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |チェックインステータス|チェックインステータスを未チェックインに更新する|呼び出し元より渡された情報||  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acceptanceCancelPost(
    generated?: PostCheckinCancelRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostCheckinCancelResponse>;
  public acceptanceCancelPost(
    generated?: PostCheckinCancelRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostCheckinCancelResponse>>;
  public acceptanceCancelPost(
    generated?: PostCheckinCancelRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostCheckinCancelResponse>>;
  public acceptanceCancelPost(
    generated?: PostCheckinCancelRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/acceptance/cancel`;
    return this.httpClient.request<PostCheckinCancelResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： チェックイン確定&lt;br&gt; チェックイン可否判定を行い、DxAPIで指定したjourneyのチェックインを行う。&lt;br&gt; DxAPIから返却されたチェックイン結果がスタンバイチェックインであるかつ、予約が社員用PNRではない場合、&lt;br&gt; スタンバイチェックインとなったセグメント以降のセグメントに対してチェックイン取り消しを行う。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエストから受け取ったjourneyIDをDxAPIに渡し、CPR情報を検索する。&lt;br&gt; DxAPIのレスポンスの結果がエラー、検索結果が0件の場合、HTTPステータス400を返却する。  1. journeyをもとにDxAPIを呼び出し、PNR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. journeyをもとにAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、CPR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. Altea Web Serviceから取得したCPR情報においてチェックイン順序チェック要である搭乗者・セグメントについて、journeyをもとにセグメント単位でAltea Web Service(DCSETK_CheckRevenueIntegrity)を呼び出し、チェックイン順序チェックの判定結果を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。    1. リクエスト項目に該当する搭乗者・セグメントのみをチェックイン対象とし、チェックイン状況を確認する。&lt;br&gt; 取得したCPR情報、PNR情報およびチェックイン順序チェック判定結果をもとにCPR取得APIのチェックイン可否判定のロジックと同じ処理を行い、チェックイン不可の場合はチェックイン対象から除外する。&lt;br&gt; (チェックイン可否判定の処理内容はCPR取得APIのレスポンス項目「チェックイン不可理由」のdescriptionを参照)&lt;br&gt; 全ての搭乗者・セグメントがチェックイン不可となった場合はHTTPステータス400を返却する。  1. Journeyに含まれる全てのセグメントおよび全ての搭乗者をチェックイン対象とする場合、以下のチェックイン処理を行う。   1. journeyIDをDxAPIに渡してチェックインを行う。チェックインの結果をjourneyElementID単位で判定する。   1. DxAPIから返却されたチェックイン結果にスタンバイチェックインである搭乗者・セグメントが存在し、かつ予約が社員用PNRではない場合、&lt;br&gt;   スタンバイチェックインとなった搭乗者の、以降のセグメントに対してDxAPIを呼び出しチェックイン取り消し処理を行う。   1. チェックインおよびチェックイン取り消しにて予期せぬエラーが発生した場合、HTTPステータス500を返却する。  1. Journeyに含まれる一部のセグメント・搭乗者をチェックイン対象とする場合、以下のチェックイン処理を行う。   1. journeyElementIDをチェックイン可能な出発日時の早いセグメントから順にDxAPIに渡してチェックインを搭乗者・セグメント毎に行う。   1. DxAPIから返却されたチェックイン結果が以下のいずれかの場合は後続セグメントのチェックインは実施しないで \&quot;チェックイン不可\&quot; として扱い、次の搭乗者のセグメントのチェックインを行う。     |No|条件|     |---:|:---|     |1|スタンバイチェックインで、かつ予約が社員用PNRではない|      |2|チェックインが失敗した|   1. DxAPIから返却されたチェックイン結果にスタンバイチェックインである搭乗者・セグメントが存在し、かつ予約が社員用PNRではない場合、&lt;br&gt;   スタンバイチェックインとなった搭乗者の、以降のセグメントに対してDxAPIを呼び出しチェックイン取り消し処理を行う。  1. チェックインおよびチェックイン取り消しにて予期せぬエラーが発生した場合、HTTPステータス500を返却する。（後続の搭乗者・セグメントの処理は行わない）  1. 元々SUBLOだったがチェックインが成功し座席が自動アサインされた搭乗者が存在する場合はワーニングを設定する  1. 1つでもチェックインまたはスタンバイチェックインが完了したセグメント・搭乗者が存在する場合HTTPステータス201、そうでない場合はHTTPステータス400を返却する。  # 3. データ更新内容 1. CPR   |更新フィールド|更新内容|データ取得元|条件等|   |:---|:---|:---|:---|   |チェックインステータス|チェックインステータスをチェックイン済みに更新する|呼び出し元より渡された情報||  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acceptancePost(
    generated?: PostCheckinConfirmRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostCheckinConfirmResponse>;
  public acceptancePost(
    generated?: PostCheckinConfirmRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostCheckinConfirmResponse>>;
  public acceptancePost(
    generated?: PostCheckinConfirmRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostCheckinConfirmResponse>>;
  public acceptancePost(
    generated?: PostCheckinConfirmRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/acceptance`;
    return this.httpClient.request<PostCheckinConfirmResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 処理名： 同行者追加&lt;br&gt; 予約番号または航空券番号と姓名で、同行者のCPR情報（journey）を取得する。&lt;br&gt; 元々存在する搭乗者(チェックイン対象選択で表示している搭乗者)のCPR情報と同行者のCPR情報を比較し、同行者追加可否判定を行う。&lt;br&gt;判定結果が追加可能であればDxAPIを呼び出し、元々の搭乗者のjourneyに同行者の情報を追加する。&lt;br&gt; 判定結果が不可であれば不可理由を返却する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目のバリデーションチェックを行う。&lt;br&gt; 以下のいずれかの条件に合致した場合、HTTPステータス400を返却する。    |No|条件|   |---:|:---|   |1|予約番号検索かつ、予約番号がリクエスト項目に存在しない|   |2|航空券番号検索かつ、航空券番号がリクエスト項目に存在しない|   |3|搭乗者名と搭乗者姓の合計桁数が56桁以上である|  1. リクエスト項目をもとにDxAPIを呼び出し、元々の搭乗者のCPR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、検索結果が0件の場合、HTTPステータス400を返却する。  1. 元々の搭乗者のCPR情報とリクエスト項目から、同行者の追加上限を確認する。&lt;br&gt; 元々の搭乗者数と追加する同行者数の合計が9名を超える場合、HTTPステータス400を返却する。  1. 元々の搭乗者のjourneyをもとにDxAPIを呼び出し、PNR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 元々の搭乗者のjourneyをもとにAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、CPR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. リクエスト項目の同行者毎に以下の処理を行い、追加対象の同行者情報を抽出する。    1. リクエスト項目をもとにDxAPIを呼び出し、同行者のjourneyをjourneyID取得のために検索する。&lt;br&gt;   レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。    1. 検索した同行者のjourneyから、同一PNRに同姓同名の搭乗者が2人以上存在し、CPR情報が複数返却されないかを確認する。&lt;br&gt;   同姓同名の搭乗者が2人以上存在する場合、HTTPステータス400を返却する。    1. 検索した同行者のjourneyから、元々の搭乗者のjourneyと同行者のjourneyの確定済みセグメントが一致するかを確認する。&lt;br&gt;   確定済みセグメントのjourneyが一致する場合、追加対象とする。&lt;br&gt;   追加対象の同行者のjourneyが0件もしくは確定済みセグメントのjourneyが複数になった場合、HTTPステータス400を返却する。    1. 同行者のjourneyIDをもとにDxAPIを呼び出し、同行者のCPR情報を取得する。&lt;br&gt;   レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。    1. 同行者のjourneyをもとにDxAPIを呼び出し、同行者のPNR情報を取得する。&lt;br&gt;   レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。       1. 同行者のjourneyをもとにAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、CPR情報を取得する。&lt;br&gt;   レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。    1. Altea Web Serviceから取得した同行者のCPR情報においてチェックイン順序チェック要であるjourneyElementについて、journeyをもとにセグメント単位でAltea Web Service(DCSETK_CheckRevenueIntegrity)を呼び出し、チェックイン順序チェックの判定結果を取得する。&lt;br&gt;   レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。    1. リクエスト項目の同行者名と同行者姓に該当するCPR情報、PNR情報を同行者の追加対象とする。    1. 元々の搭乗者と同行者のCPR情報をもとに、同行者追加可否判定を行う。&lt;br&gt;   以下のいずれかの条件に合致した場合、同行者追加不可とし、不可理由に対応するメッセージIDをレスポンス項目として設定、&lt;br&gt;HTTPステータス400を返却する。      |No|条件|     |---:|:---|     |1|元々の搭乗者と同行者が、同じ予約番号または航空券番号で一致する|     |2|同行者のセグメント情報がチェックイン対象選択画面に表示しているセグメントの情報と一致しない&lt;br&gt; （セグメント数、各セグメントの便名/出発日時/出発地/到着地/キャビンクラスが一致しないこと）|     |3|社員用PNRと非社員用PNRが混在する|     |4|REBATE STAFFとDUTY STAFFが混在する|     |5|予約番号検索で、検索した予約がグループPNRである|    1. 同行者のCPR情報とPNR情報をもとに、チェックイン可否を判定する。&lt;br&gt;   (チェックイン可否判定の処理内容はCPR取得APIのレスポンス項目「チェックイン不可理由」のdescriptionを参照)&lt;br&gt;   チェックイン可否判定の結果、チェックイン不可と判定された場合、不可理由に対応するメッセージIDをレスポンス項目として設定、HTTPステータス400を返却する。  1. 追加対象の同行者情報をもとにDxAPIを呼び出し、同行者を追加する。&lt;br&gt; 同行者追加可否判定結果が可、かつチェックイン可否判定結果が可の場合、DxAPIを呼び出し、元々の搭乗者のjourneyに同行者の情報を追加する。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス400を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addCompanionPost(
    generated?: PostAddCompanionRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostAddCompanionResponse>;
  public addCompanionPost(
    generated?: PostAddCompanionRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostAddCompanionResponse>>;
  public addCompanionPost(
    generated?: PostAddCompanionRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostAddCompanionResponse>>;
  public addCompanionPost(
    generated?: PostAddCompanionRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/add-companion`;
    return this.httpClient.request<PostAddCompanionResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： Walletデータ取得&lt;br&gt; 指定したセグメント/搭乗者の搭乗券を発行し、連携GWで搭乗券発行に必要となるデータをBase64で暗号化して画面側へ返却する。&lt;br&gt; 搭乗券が発行可能の場合は、搭乗券を発行し、発行不可の場合や搭乗券発行時にSelectee制限になった便がある場合は搭乗券を発行しない。&lt;br&gt; リクエストから受け取ったjourneyIDをDxAPIに渡し、journey(スルーチェックイン可能なCPRを1つにまとめたデータ)を検索する。&lt;br&gt; 検索したjourneyを基に搭乗券発行対象を抽出し、搭乗券発行対象がない場合はエラーとする。&lt;br&gt; 搭乗券発行対象がある場合は、DxAPIを呼び出しQRコードを含む搭乗券情報を取得する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにDxAPIを呼び出し、journeyを取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。  1. journeyをもとにAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、CPR情報に含まれる航空券番号を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. journeyをもとにDxAPIを呼び出し、PNR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. NHグループ運航便かつSTDまで48時間未満であるセグメントについて、発着APIを呼び出し、計画出発日時と最新出発日時を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合でも、ワーニングを返却するのみとし、処理は継続する。&lt;br&gt; ※CPR取得APIの最新運航情報を取得する処理と同じ。  1. 搭乗券発行対象の搭乗者/セグメントを抽出する。&lt;br&gt; リクエストより連携された搭乗者ID、フライトIDを基にjourneyから、以下の条件に合致する搭乗者/セグメントを抽出する。&lt;br&gt; 抽出した結果、搭乗者/セグメントが0件の場合、HTTPステータス400を返却する。    |No|条件|   |---:|:---|   |1|チェックインステータスがチェックイン済み/スタンバイチェックイン済みである|   |2|他社運航便のセグメントではない|   |3|セグメントが1便目の場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である|   |4|セグメントが2便目以降の場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である、または直前の便が未出発である|  1. 搭乗券発行対象のセグメントにSuffix便が含まれているか判定する。&lt;br&gt; Suffix便が含まれている場合、HTTPステータス400を返却する。  1. 搭乗券発行対象の搭乗者/セグメントの1便目について、Altea Web Serviceから取得したCPR情報においてチェックイン順序チェック要である場合、journeyをもとにAltea Web Service(DCSETK_CheckRevenueIntegrity)を呼び出し、チェックイン順序チェックの判定結果を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 搭乗券発行対象に1便目がオンラインチェックイン不可の搭乗者が存在するか判定する。&lt;br&gt; 搭乗券発行対象の搭乗者/セグメントの1便目について、以下のいずれかの条件に合致する場合、搭乗券発行不可としてHTTPステータス400を返却する。    |No|条件|   |---:|:---|   |1|journey内に1便でもNHグループ運航NHグループ便名、かつ席あり幼児を制限しているACV・キャビンクラスで、搭乗者に席あり幼児（INS）が存在する|   |2|1便でも未発券のセグメントが存在する搭乗者である|   |3|複数チェックイン対象便があり、1便目が未チェックインにも関わらず、2便目以降がチェックイン済みである&lt;br&gt;もしくは、複数チェックイン対象便があり、未チェックインが間に存在する|   |4|SKにPRIS/ARMDが存在する|   |5|搭乗者がHigh Priority制限を保持し、かつ以下のいずれかに該当する&lt;br&gt;1. Acceptance comment(ACC)が登録されている&lt;br&gt;2. Next comment(NXT)が登録されている|   |6|SSR EXSTまたはSSR CBBGが存在する|   |7|Altea Web Serviceによるチェックイン順序チェックの結果、チェックイン不可である|  1. 抽出した搭乗者/セグメントがWallet発行可能か判定する。&lt;br&gt; 抽出した搭乗者/セグメントで以下の条件のいずれかに合致する場合は、HTTPステータス400を返却する。    |No|条件|   |---:|:---|   |1|journeyの搭乗券発行可否が発行不可である|   |2|ASWDB(マスタ)から取得した便名ごとのQRコード発行可否が発行不可である|   |3|ASWDB(マスタ)から便名ごとのQRコード発行可否が取得できない、かつ、ASWDB(マスタ)から取得した空港ごとのQRコード発行可否が発行不可である|   |4|搭乗者に、設定ファイルのキーワードがSKに登録されている|  1. DxAPIを呼び出し、搭乗券発行を行う。&lt;br&gt; DxAPIのレスポンスの結果がエラー、もしくは、エラーではないが以下の条件に合致する場合はHTTPステータス400を返却する。&lt;br&gt; エラーではないが米国発の便でバーコードが取得不可の場合はHTTPステータス500を返却する。    |No|条件|   |---:|:---|   |1|搭乗券発行のレスポンスの結果にSelectee制限ありの搭乗者/セグメントがある|   |2|リクエストされた全搭乗者の1便目にSelectee制限がある|   |3|搭乗券発行のレスポンスのうち搭乗券発行結果のステータスが発行制限である|  1. 連携GWへの連携情報を暗号化する。&lt;br&gt; 搭乗券発行のレスポンスから連携情報の各項目をDESを用いて暗号化し、Base64にエンコードする。&lt;br&gt; 連携情報データの生成にあたり、搭乗券発行のレスポンスで不足している項目がある場合、journeyおよびCPR情報を利用して不足している項目を補う。&lt;br&gt; 同伴幼児の座席番号は、DxAPIから取得できた場合でも\&quot;INF\&quot;を設定する。&lt;br&gt; 暗号化に失敗した場合は、HTTPステータス500を返却し、journeyおよびCPR情報を利用しても補えない項目がある場合は、HTTPステータス400を返却する。  # 3. データ更新内容 1. CPR |更新フィールド|更新内容|データ取得元| |:---|:---|:---| |搭乗券発行ステータス|搭乗券発行ステータスを\&quot;発行済み\&quot;に更新する|呼び出し元より渡された情報|  # 4. 特記事項 - なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public boardingPassesGetWalletPost(
    generated?: PostBoardingPassesGetWalletRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostBoardingPassesGetWalletResponse>;
  public boardingPassesGetWalletPost(
    generated?: PostBoardingPassesGetWalletRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostBoardingPassesGetWalletResponse>>;
  public boardingPassesGetWalletPost(
    generated?: PostBoardingPassesGetWalletRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostBoardingPassesGetWalletResponse>>;
  public boardingPassesGetWalletPost(
    generated?: PostBoardingPassesGetWalletRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/boarding-passes/get-wallet`;
    return this.httpClient.request<PostBoardingPassesGetWalletResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 処理名： HPBP PDF取得&lt;br&gt; 指定したセグメント/搭乗者の搭乗券を発行し、発行した搭乗券をiCASを通じてPDFを発行する。&lt;br&gt; 搭乗券が発行可能の場合は、搭乗券を発行し、発行不可の場合は確認証を発行する。&lt;br&gt; ただし、搭乗券発行時にSelectee制限になった便がある場合は搭乗券および確認証の両方とも発行しない。&lt;br&gt; リクエストから受け取ったjourneyIDをDxAPIに渡し、搭乗券および確認証発行用のjourney(スルーチェックイン可能なCPRを1つにまとめたデータ)を検索する。&lt;br&gt; 検索したjourneyを基に搭乗券発行対象を抽出し、搭乗券発行対象がない場合はエラーとする。&lt;br&gt; 搭乗券発行対象の同一セグメントに対して、搭乗券発行対象の搭乗者でキャビンクラスが混在する場合はエラーとする。&lt;br&gt; 搭乗券発行対象がある場合は、DxAPIを呼び出しバーコードを含む搭乗券情報を取得する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにDxAPIを呼び出し、journeyを取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。  1. journeyをもとにAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、CPR情報に含まれる航空券番号を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. journeyをもとにDxAPIを呼び出し、PNR情報を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 搭乗券発行対象の搭乗者/セグメントを抽出する。&lt;br&gt; リクエストより連携された搭乗者ID、フライトIDを基にjourneyから、以下の条件に合致する搭乗者/セグメントを抽出する。&lt;br&gt; 抽出した結果、搭乗者/セグメントが0件の場合、HTTPステータス400を返却する。&lt;br&gt;    |No|条件|   |---:|:---|   |1|チェックインステータスがチェックイン済み/スタンバイチェックイン済みである|   |2|セグメントが他社運航便の場合、当該便より前の便で搭乗券発行可能なNHグループ運航便が存在する|   |3|セグメントが1便目の場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である|   |4|セグメントが2便目以降の場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である、または直前の便が未出発である|  1. 搭乗券発行対象の搭乗者/セグメントでキャビンクラスが混在するか判定する。&lt;br&gt; 搭乗券発行対象の同一セグメントで、搭乗券発行対象の搭乗者でキャビンクラスが混在する場合、HTTPステータス400を返却する。  1. 搭乗券発行対象のセグメントにSuffix便が含まれているか判定する。&lt;br&gt; Suffix便が含まれている場合、HTTPステータス400を返却する。  1. 搭乗券発行対象の搭乗者/セグメント毎にDxAPIを呼び出し、FFP情報を取得する。&lt;br&gt; 搭乗者/セグメントに紐づくFFP情報が0件であってもエラーにはせずに後続の処理を実行する。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス400を返却する。  1. 搭乗券発行対象の搭乗者/セグメントの1便目について、Altea Web Serviceから取得したCPR情報においてチェックイン順序チェック要である場合、journeyをもとにAltea Web Service(DCSETK_CheckRevenueIntegrity)を呼び出し、チェックイン順序チェックの判定結果を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 搭乗券発行対象に1便目がオンラインチェックイン不可の搭乗者が存在するか判定する。&lt;br&gt; 搭乗券発行対象の搭乗者/セグメントの1便目について、以下のいずれかの条件に合致する場合、搭乗券発行不可としてHTTPステータス400を返却する。    |No|条件|   |---:|:---|   |1|journey内に1便でもNHグループ運航NHグループ便名、かつ席あり幼児を制限しているACV・キャビンクラスで、搭乗者に席あり幼児（INS）が存在する|   |2|1便でも未発券のセグメントが存在する搭乗者である|   |3|複数チェックイン対象便があり、1便目が未チェックインにも関わらず、2便目以降がチェックイン済みである&lt;br&gt;もしくは、複数チェックイン対象便があり、未チェックインが間に存在する|   |4|SKにPRIS/ARMDが存在する|   |5|搭乗者がHigh Priority制限を保持し、かつ以下のいずれかに該当する&lt;br&gt;1. Acceptance comment(ACC)が登録されている&lt;br&gt;2. Next comment(NXT)が登録されている|   |6|SSR EXSTまたはSSR CBBGが存在する|   |7|Altea Web Serviceによるチェックイン順序チェックの結果、チェックイン不可である|  1. 搭乗券か確認証のどちらを発行するか判定する。&lt;br&gt; 搭乗者/セグメント毎に以下の判定を行い、条件にすべて合致しない場合は、その搭乗者/セグメントに対して発行するものを搭乗券とする。1つでも合致する場合、確認証とする。    |No|条件|備考|   |---:|:---|:---|   |1|journeyの搭乗券発行可否が発行不可である|||   |2|他社運航便以外の場合、ASWDB(マスタ)から取得した便名ごとのHPBP発行可否が発行不可である|||   |3|他社運航便以外の場合、ASWDB(マスタ)から便名ごとのHPBP発行可否が取得できない、かつ、ASWDB(マスタ)から取得した空港ごとのHPBP発行可否が発行不可である||   |4|搭乗者に、設定ファイルのキーワードがSKに登録されている||   |5|他社運航便のセグメントである、かつ、第一出発便の搭乗券発行可否が発行不可である|||    1. 搭乗券発行対象の搭乗者/セグメントの場合、搭乗券発行を行い、PDF用の搭乗券データを生成する。&lt;br&gt;   搭乗券発行対象の搭乗者/セグメントの場合、以下の処理を実施する。      1. 発行対象の搭乗者/セグメントをDxAPIに渡し、搭乗券発行を行う。&lt;br&gt;     DxAPIのレスポンスの結果がエラー、もしくは、エラーではないが以下の条件に合致する場合はHTTPステータス400を返却する。&lt;br&gt;     エラーではないが米国発の便でバーコードが取得不可の場合はHTTPステータス500を返却する。     米国発の便以外でバーコード取得不可の場合、確認証発行対象とする。          |No|条件|         |---:|:---|         |1|搭乗券発行のレスポンスの結果にSelectee制限ありの搭乗者/セグメントがある|         |2|リクエストされた全搭乗者の1便目にSelectee制限がある|         |3|搭乗券発行のレスポンスのうち搭乗券発行結果のステータスが発行制限である|      1. 搭乗券発行のレスポンスから、PDF用の搭乗券データを生成する。&lt;br&gt;     PDF用の搭乗券データの生成にあたり、搭乗券発行のレスポンスでは不足している項目がある場合、journeyおよびCPR情報を利用して不足している項目を補う。&lt;br&gt;     同伴幼児の座席番号は、DxAPIから取得できた場合でも\&quot;INF\&quot;を設定する。    1. 確認証発行対象の搭乗者/セグメントの場合、PDF用の確認証データを生成する。&lt;br&gt;   確認証発行対象の搭乗者/セグメントの場合、journeyおよびCPR情報から、PDF用の確認証データを生成する。  1. 搭乗券データおよび確認証データをiCASに渡し、iCASが作成したPDFの搭乗券/確認証のPDFデータを受け取る。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス400を返却する。  1. 搭乗券/確認証をエンコードする。&lt;br&gt; 作成した搭乗券/確認証をBase64にエンコードする。  # 3. データ更新内容 1. CPR |更新フィールド|更新内容|データ取得元| |:---|:---|:---| |搭乗券発行ステータス|搭乗券発行ステータスを\&quot;発行済み\&quot;に更新する|呼び出し元より渡された情報|  # 4. 特記事項 - なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public boardingPassesIssueHpbpPost(
    generated?: PostBoardingPassesIssueHpbpRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostBoardingPassesIssueHpbpResponse>;
  public boardingPassesIssueHpbpPost(
    generated?: PostBoardingPassesIssueHpbpRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostBoardingPassesIssueHpbpResponse>>;
  public boardingPassesIssueHpbpPost(
    generated?: PostBoardingPassesIssueHpbpRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostBoardingPassesIssueHpbpResponse>>;
  public boardingPassesIssueHpbpPost(
    generated?: PostBoardingPassesIssueHpbpRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/boarding-passes/issue-hpbp`;
    return this.httpClient.request<PostBoardingPassesIssueHpbpResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 処理名： MBPメール送信&lt;br&gt; 指定したセグメント/搭乗者の搭乗券を発行し、発行した搭乗券(QRコード含む)をiCASを通じてメール送信する。&lt;br&gt; 搭乗券が発行可能の場合は、搭乗券を発行し、発行不可の場合は確認証を発行する。&lt;br&gt; ただし、搭乗券発行時にSelectee制限になった便がある場合や他社便の場合は搭乗券および確認証の両方とも発行しない。&lt;br&gt; リクエストから受け取ったjourneyIDをDxAPIに渡し、搭乗券および確認証発行用のjourney(スルーチェックイン可能なCPRを1つにまとめたデータ)を検索する。&lt;br&gt; 検索したjourneyを基に搭乗券発行対象を抽出し、搭乗券発行対象がない場合はエラーとする。&lt;br&gt; 搭乗券発行対象の同一セグメントに対して、搭乗券発行対象の搭乗者でキャビンクラスが混在する場合はエラーとする。&lt;br&gt; 搭乗券発行対象がある場合は、DxAPIを呼び出しQRコードを含む搭乗券情報を取得する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにDxAPIを呼び出し、journeyを取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。  1. journeyをもとにAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、CPR情報に含まれる航空券番号を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. journeyをもとにDxAPIを呼び出し、PNR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 搭乗券発行対象の搭乗者/セグメントを抽出する。&lt;br&gt; リクエストより連携された搭乗者ID、フライトIDを基にjourneyから、以下の条件に合致する搭乗者/セグメントを抽出する。&lt;br&gt; 抽出した結果、搭乗者/セグメントが0件の場合、HTTPステータス400を返却する。    |No|条件|   |---:|:---|   |1|チェックインステータスがチェックイン済み/スタンバイチェックイン済みである|   |2|他社運航便のセグメントではない|   |3|セグメントが1便目の場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である|   |4|セグメントが2便目以降の場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である、または直前の便が未出発である|  1. 搭乗券発行対象の搭乗者/セグメントでキャビンクラスが混在するか判定する。&lt;br&gt; 搭乗券発行対象の同一セグメントで、搭乗券発行対象の搭乗者でキャビンクラスが混在する場合、HTTPステータス400を返却する。  1. 搭乗券発行対象のセグメントにSuffix便が含まれているか判定する。&lt;br&gt; Suffix便が含まれている場合、HTTPステータス400を返却する。  1. 搭乗券発行対象の搭乗者/セグメント毎にDxAPIを呼び出し、FFP情報を取得する。&lt;br&gt; 搭乗者/セグメントに紐づくFFP情報が0件であってもエラーにはせずに後続の処理を実行する。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス400を返却する。   1. 搭乗券発行対象の搭乗者/セグメントの1便目について、Altea Web Serviceから取得したCPR情報においてチェックイン順序チェック要である場合、journeyをもとにAltea Web Service(DCSETK_CheckRevenueIntegrity)を呼び出し、チェックイン順序チェックの判定結果を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。   1. 搭乗券発行対象に1便目がオンラインチェックイン不可の搭乗者が存在するか判定する。&lt;br&gt; 搭乗券発行対象の搭乗者/セグメントの1便目について、以下のいずれかの条件に合致する場合、搭乗券発行不可としてHTTPステータス400を返却する。    |No|条件|   |---:|:---|   |1|journey内に1便でもNHグループ運航NHグループ便名、かつ席あり幼児を制限しているACV・キャビンクラスで、搭乗者に席あり幼児（INS）が存在する|   |2|1便でも未発券のセグメントが存在する搭乗者である|   |3|複数チェックイン対象便があり、1便目が未チェックインにも関わらず、2便目以降がチェックイン済みである&lt;br&gt;もしくは、複数チェックイン対象便があり、未チェックインが間に存在する|   |4|SKにPRIS/ARMDが存在する|   |5|搭乗者がHigh Priority制限を保持し、かつ以下のいずれかに該当する&lt;br&gt;1. Acceptance comment(ACC)が登録されている&lt;br&gt;2. Next comment(NXT)が登録されている|   |6|SSR EXSTまたはSSR CBBGが存在する|   |7|Altea Web Serviceによるチェックイン順序チェックの結果、チェックイン不可である|  1. 搭乗券か確認証のどちらを発行するか判定する。&lt;br&gt; 搭乗者/セグメント毎に以下の判定を行い、条件にすべて合致しない場合は、その搭乗者/セグメントに対して発行するものを搭乗券とする。1つでも合致する場合、確認証とする。    |No|条件|   |---:|:---|   |1|journeyの搭乗券発行可否が発行不可である|   |2|ASWDB(マスタ)から取得した便名ごとのQRコード発行可否が発行不可である|   |3|ASWDB(マスタ)から便名ごとのQRコード発行可否が取得できない、かつ、ASWDB(マスタ)から取得した空港ごとのQRコード発行可否が発行不可である|   |4|搭乗者に、設定ファイルのキーワードがSKに登録されている|    1. 以下の処理にて、搭乗券発行対象の搭乗者/セグメントに対して搭乗券発行を行い、メール送信用の搭乗券データを生成する。&lt;br&gt;      1. 発行対象の搭乗者/セグメントをDxAPIに渡し、搭乗券発行を行う。&lt;br&gt;     DxAPIのレスポンスの結果がエラー、もしくは、エラーではないが以下の条件に合致する場合はHTTPステータス400を返却する。&lt;br&gt;     エラーではないが米国発の便でバーコードが取得不可の場合は、HTTPステータス500を返却する。&lt;br&gt;     米国発の便以外でバーコード取得不可の場合、確認証発行対象とする。          |No|条件|         |---:|:---|         |1|搭乗券発行のレスポンスにSelectee制限ありの搭乗者/セグメントがある|         |2|リクエストされた全搭乗者の1便目にSelectee制限がある|         |3|搭乗券発行のレスポンスのうち搭乗券発行結果のステータスが発行制限である|      1. 搭乗券発行のレスポンスからメール送信用の搭乗券データを生成する。&lt;br&gt;     メール送信用の搭乗券データの生成にあたり、搭乗券発行のレスポンスでは不足している項目がある場合、journeyおよびCPR情報を利用して不足している項目を補う。&lt;br&gt;     同伴幼児の座席番号は、DxAPIから取得できた場合でも\&quot;INF\&quot;を設定する。    1. 確認証発行対象の搭乗者/セグメントの場合、メール送信用の確認証データを生成する。&lt;br&gt;   確認証発行対象の搭乗者/セグメントの場合、journeyおよびCPR情報からメール送信用の確認証データの生成を行う。  1. 搭乗券および確認証のメール送信用データをiCASへ連携しメールを送付する。&lt;br&gt; iCASのレスポンスの結果がエラーの場合、HTTPステータス400を返却する。  # 3. データ更新内容 1. CPR |更新フィールド|更新内容|データ取得元| |:---|:---|:---| |搭乗券発行ステータス|搭乗券発行ステータスを\&quot;発行済み\&quot;に更新する|呼び出し元より渡された情報|  # 4. 特記事項 - なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public boardingPassesSendMbpPost(
    generated?: PostBoardingPassesSendMbpRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public boardingPassesSendMbpPost(
    generated?: PostBoardingPassesSendMbpRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public boardingPassesSendMbpPost(
    generated?: PostBoardingPassesSendMbpRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public boardingPassesSendMbpPost(
    generated?: PostBoardingPassesSendMbpRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/boarding-passes/send-mbp`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： CKIシートマップ取得&lt;br&gt; リクエストパラメータを基にDxAPIからCPR情報を取得し、座席指定が可能かどうか判定する。&lt;br&gt; リクエストパラメータで指定されたセグメントが座席指定可能であった場合、DxAPIからシートマップ情報を取得し返却する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにDxAPIを呼び出し、CPR情報を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。&lt;br&gt; リクエストで指定されたセグメントが国際線かつ他社運航便、または国内線かつ他社運航便かつ他社便名であった場合、HTTPステータス400を返却する。&lt;br&gt; ※便名が他社の場合でも、NHグループ運航便であれば、エラーとはせず処理を継続する。&lt;br&gt;  1. リクエスト項目をもとにDxAPIを呼び出し、シートマップ情報を取得する。 レスポンスがエラーの場合、HTTPステータス400を返却する。&lt;br&gt;  1. CPR情報をもとにS03_シートマップ取得APIを呼び出し、参照用シートマップ情報（設備・通路列）を取得する。 レスポンスがエラーの場合、HTTPステータス400を返却する。  1. HTTPステータス200を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkinGetSeatmapPost(
    generated?: PostSeatmapRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostSeatmapResponse>;
  public checkinGetSeatmapPost(
    generated?: PostSeatmapRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostSeatmapResponse>>;
  public checkinGetSeatmapPost(
    generated?: PostSeatmapRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostSeatmapResponse>>;
  public checkinGetSeatmapPost(
    generated?: PostSeatmapRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/checkin/get-seatmap`;
    return this.httpClient.request<PostSeatmapResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： チェックインサービス申込&lt;br&gt; チェックインフローにおいてサービス申込全般の登録・変更・削除を行う。&lt;br&gt; 以下のサービス申込を可能とする。   1. 座席情報の登録・変更   1. チャイルドシートの登録・削除  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. DxAPIを呼び出し、journeyを取得する。&lt;br&gt; リクエストで指定されたセグメントが以下の条件のいずれかに合致した場合、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|チェックイン対象1便目のセグメントかつ受付ステータスがopenedでないかつ後続のセグメントが存在しない||   |2|チェックイン対象2便目以降のセグメントかつ受付ステータスがopenedでない、かつ直前の便が出発済であるセグメントが存在する||  検索結果が取得できた場合、出発済みの便をjourneyから除外する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、または出発済みの便を除外した結果journey内の便が0件となった場合、HTTPステータス400を返却する。  1. サービス申込利用可否判定を行う。&lt;br&gt; 以下の全ての条件に合致した場合、サービス申込利用不可とし、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|journeyの搭乗者について、社員種別が設定されている搭乗者が一人でも存在する||   |2|リクエストのセグメントが空席利用である|空席利用かどうかはCPR取得APIの処理を利用する|   |3|リクエストのセグメントが未チェックインである||  1. journeyをもとにリクエストで指定したセグメントのシートマップ情報を取得する。&lt;br&gt; また、リクエストにてチャイルドシート申込が設定されている、かつ、更新区分が登録である搭乗者がいる場合、当該セグメント以外のチェックイン対象となるNHグループ運航便のセグメントに対しシートマップ情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。&lt;br&gt;   1. DxAPIを呼び出し、シートマップ情報を取得する。&lt;br&gt;   1. S03_シートマップ取得APIを呼び出し、参照用シートマップ情報（通路列）を取得する。  1. journeyをもとにDxAPIを呼び出し、PNR情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 同伴幼児着席可否判定を行う。&lt;br&gt; 搭乗者とリクエストで指定した座席について、同伴幼児ありの搭乗者が指定した座席が同伴幼児着席不可である場合、同伴幼児着席不可の席を選択したとし、HTTPステータス400を返却する。&lt;br&gt; なお、直営外PNRでリクエストのセグメントが未チェックインである場合は、リクエストの全搭乗者を判定対象とし、それ以外の場合は、リクエストで指定した座席番号とjourneyで指定済みの座席番号が異なる搭乗者のみを判定対象とする。&lt;br&gt; 座席が同伴幼児着席不可であるかは、CKIシートマップ取得APIの同伴幼児着席可能かどうかの判定処理を利用する  1. 座席指定可否判定を行う。&lt;br&gt; journeyの指定済みの座席、および、リクエストで指定した搭乗者毎の座席について、以下のいずれかの条件に合致した場合、座席指定不可とし、HTTPステータス400を返却する。&lt;br&gt; リクエストで指定した座席番号とjourneyで指定済みの座席番号が同じ搭乗者は当判定を行わないものとする。    |No|条件|備考|   |---:|:---|:---|   |1|journeyで指定済みの座席が変更不可である|CKIシートマップ取得APIの座席変更不可かどうかの判定処理を利用する|   |2|リクエストで指定した座席について、journeyで指定済みの座席と比較し、搭乗者同士による座席の付け替えが行われている||  1. チャイルドシート利用可否判定を行う。&lt;br&gt; リクエストにてチャイルドシート申込が設定されている場合、&lt;br&gt; もしくは、journeyのSSR/SKにチャイルドシートが登録されている、かつ、リクエストのチャイルドシート申込が設定されていない、かつ、リクエストで指定されている座席番号がjourneyで指定済みの座席番号と異なる搭乗者がいる場合、当判定を行う。&lt;br&gt; このとき、下記いずれかの条件に合致した場合、チャイルドシート利用不可とし、HTTPステータス400を返却する。&lt;br&gt; また、当該セグメント以外のチェックイン対象となるセグメントに対し座席指定が行われている場合、そのセグメントに対しても同様にチャイルドシート利用可否判定を行う。    |No|条件|備考|   |---:|:---|:---|   |1|チャイルドシートの設置が不可な座席を選択した|CKIシートマップ取得APIのチャイルドシート設置可能席かどうかの判定処理を利用する。更新区分が削除の場合のみ判定しない|   |2|チェックイン対象のセグメントに他社運航便が含まれている||   |3|チェックイン対象のセグメントにチャイルドシート制限機材が含まれている||  1. journeyを基にAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、チャイルドシートの登録、削除に必要なCPR情報を取得する。&lt;br&gt; リクエストにてチャイルドシート申込が設定されている搭乗者がいない場合、当処理を実行せず後続の処理を行う。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 搭乗者毎にDxAPIを呼び出し、座席指定情報を登録・更新する。&lt;br&gt; リクエストで指定した座席番号とjourneyで指定済みの座席番号が同じ搭乗者は更新対象外とする。&lt;br&gt;   1. 非常口座席の適合性更新を行う。&lt;br&gt;   リクエストで指定された座席が非常口座席と一致しない場合、当処理を実行せず後続の処理を行う。&lt;br&gt;   レスポンスがエラーの場合、ワーニングを返却するのみとし、次の搭乗者の処理に移る。&lt;br&gt;   1. 座席指定情報の登録・更新処理を行う。&lt;br&gt;   途中で座席指定に失敗しても処理を中断せずに全搭乗者に対し座席指定情報の登録・更新を行う。&lt;br&gt;   このとき、全搭乗者に対し、レスポンスがエラーの場合、または、レスポンスは正常だが座席指定に失敗し、リクエストとレスポンスの座席番号が一致しない場合、搭乗者とメッセージIDをレスポンス項目として設定し、HTTPステータス400を返却し処理を終了する。&lt;br&gt;   一人でも座席指定に成功した場合、座席指定に失敗した搭乗者はワーニングを返却するのみとし、失敗した搭乗者を除き後続のチャイルドシートの登録・削除処理を行う。  1. チャイルドシートの登録・削除を行う。&lt;br&gt; リクエストにてチャイルドシート申込が設定されてきた搭乗者をチャイルドシートを申し込んだ搭乗者とみなし、当該搭乗者のチェックイン対象となる全セグメントに対し、チャイルドシートの登録・削除を行う。&lt;br&gt; なお、リクエストにてチャイルドシート申込が設定されてこなかった搭乗者は当処理を実施しない。&lt;br&gt; このとき、リクエストのチャイルドシート申込の更新区分が登録の場合、チャイルドシートの登録、更新区分が削除の場合、チャイルドシートの削除を行う。&lt;br&gt; チャイルドシートの登録・削除はAltea Web Service(DCSCPR_EditCPR)で行うが、1回のリクエストでまとめて全搭乗者、全セグメントのチャイルドシートの登録・削除を行うものとする。&lt;br&gt; レスポンスがエラーの場合でもワーニングを返却するのみとし、処理を継続する。  1. HTTPステータス201を返却する。  # 3. データ更新内容 1. CPR |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |SSR|SSRコード&#x3D;RQST|リクエストパラメータの登録する座席情報|| |SK|SKコード&#x3D;CHST|リクエストパラメータのチャイルドシート申込|リクエストパラメータのチャイルドシート申込が設定されてきた搭乗者である|  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkinServicesPost(
    generated?: PostServicesRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public checkinServicesPost(
    generated?: PostServicesRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public checkinServicesPost(
    generated?: PostServicesRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public checkinServicesPost(
    generated?: PostServicesRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/checkin/services`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： 同行者削除&lt;br&gt; journeyから、対象の搭乗者を削除する。 削除後に当該journeyを利用すると、削除された搭乗者は処理対象にならない。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにDxAPIを呼び出し、journeyから対象の搭乗者を削除する。 レスポンスがエラーの場合、HTTPステータス400を返却する。  1. HTTPステータス204を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 DxAPIの制約により、同伴幼児と付き添いの大人はセットでリクエストする必要がある。
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCompanionPost(
    generated?: PostDeleteCompanionRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public deleteCompanionPost(
    generated?: PostDeleteCompanionRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public deleteCompanionPost(
    generated?: PostDeleteCompanionRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public deleteCompanionPost(
    generated?: PostDeleteCompanionRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/delete-companion`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： フライトリスト取得&lt;br&gt; リクエストから受け取った検索項目をもとにAltea Web Serviceに接続し、フライトを検索する。&lt;br&gt; 取得したフライトのリストをもとに、Onload StatusをAltea Web Serviceから、最新運航情報を発着APIから取得する。&lt;br&gt; 取得した情報をもとに各種の業務的判定処理を行い、判定結果および取得した情報を返却する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. リクエスト項目のバリデーションチェックを行う。&lt;br&gt; 以下のいずれかの条件に合致した場合、HTTPステータス400を返却する。   |No|エラー条件|   |---:|:---|   |1|出発空港コードと到着空港コードが同一の値である|   |2|出発空港コードまたは到着空港コードが、表示可能な日本の空港としてASWDB（マスタ）に存在しない|   |3|検索開始出発時刻が検索終了出発時刻よりも後である|  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにAltea Web Service(DCSLST_FlightListDisplay)を呼び出し、フライトを検索する。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス400を返却する。  1. 検索結果のフライトのリストから、以下のすべての条件に合致するフライトのみを返却対象とし、それ以外のフライトを除外する。&lt;br&gt;   |No|条件|   |---:|:---|   |1|NHグループ運航便である|   |2|出発時刻が現在時刻よりも後である|    除外した結果、フライトが0件となってしまう場合、HTTPステータス400を返却する。  1. フライト数分、Altea Web Service(DCSLST_GetCheckInSummaryFigures)を呼び出し、Onload Statusを取得する。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス500を返却する。  1. フライト数分、発着APIを呼び出し、最新運航情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. HTTPステータス200を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public flightsGetFlightsPost(
    generated?: PostFlightsSearchFlightsRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostFlightsSearchFlightsResponse>;
  public flightsGetFlightsPost(
    generated?: PostFlightsSearchFlightsRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostFlightsSearchFlightsResponse>>;
  public flightsGetFlightsPost(
    generated?: PostFlightsSearchFlightsRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostFlightsSearchFlightsResponse>>;
  public flightsGetFlightsPost(
    generated?: PostFlightsSearchFlightsRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/flights/get-flights`;
    return this.httpClient.request<PostFlightsSearchFlightsResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 処理名： CPR情報取得&lt;br&gt; リクエストから受け取ったjourneyIDをDxAPIに渡し、journey(スルーチェックイン可能なCPRを1つにまとめたデータ)を取得する。&lt;br&gt; journeyとして返却されない一部の項目については、journeyに紐づくPNR情報をDxAPIから、また搭乗状況をAltea Web Serviceから取得する。&lt;br&gt; journeyをもとに、セグメントが一定の条件を満たす場合、セグメントの最新運航情報を発着APIから取得する。&lt;br&gt; 取得した情報をもとに各種の業務的判定処理を行い、判定結果および取得した情報を返却する。  ### 【アクセス情報】&lt;br&gt; 外部からの呼び出しは、以下のURLとする。   | 環境 | URL |  | :--- | :--- |  | 本番 | https://space.ana.co.jp/aswbe-checkin/api/v1/journeys/get-journey |  | ステージング |https://stg.test.space.ana.co.jp/stg1/aswbe-checkin/api/v1/journeys/get-journey&lt;br&gt;https://stg.test.space.ana.co.jp/stg2/aswbe-checkin/api/v1/journeys/get-journey |  | 開発 | https://dev.test.space.ana.co.jp/dev1/aswbe-checkin/api/v1/journeys/get-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev2/aswbe-checkin/api/v1/journeys/get-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev3/aswbe-checkin/api/v1/journeys/get-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev4/aswbe-checkin/api/v1/journeys/get-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev5/aswbe-checkin/api/v1/journeys/get-journey |  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにDxAPIを呼び出し、journeyを取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス400を返却する。  1. イレギュラーが発生したセグメントがjourneyに存在する、かつリクエストでUN便取得要が指定されている場合、DxAPIを呼び出し、UN便のjourneyを検索する。 レスポンスがエラー、もしくは取得結果が0件の場合でも、処理は継続する。  1. journeyをもとにDxAPIを呼び出し、RegulatoryCheck結果を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. journeyをもとにDxAPIを呼び出し、PNR情報を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. journeyをもとにDxAPIを呼び出し、Dynamic Waiverの登録状況を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. journeyをもとにAltea Web Service(DCSIDC_CPRIdentification)を呼び出し、CPR情報を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 未出発のセグメントを返却対象とし、それ以外のjourneyElement(CPR)を除外する。     ただし、リクエストに選択済みセグメントが設定されている場合は、選択済みでないセグメントも除外する。&lt;br&gt;     除外した結果、CPRが0件となってしまう場合、HTTPステータス400を返却する。  1. Altea Web Serviceから取得したCPR情報においてチェックイン順序チェック要であるjourneyElementについて、journeyをもとにセグメント単位でAltea Web Service(DCSETK_CheckRevenueIntegrity)を呼び出し、チェックイン順序チェックの判定結果を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. NHグループ運航便かつSTDまで48時間未満であるセグメントについて、発着APIを呼び出し、最新運航情報を取得する。 レスポンスがエラー、もしくは、取得結果が0件の場合でも、ワーニングを返却するのみとし、処理は継続する。  1. HTTPステータス200を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 - グループPNRの場合は、Altea側で対象の搭乗者以外の情報が削除された状態でjourneyが返却されるため、APIとしては考慮不要。
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public journeysGetJourneyPost(
    generated?: PostJourneysGetJourneyRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostJourneysGetJourneyResponse>;
  public journeysGetJourneyPost(
    generated?: PostJourneysGetJourneyRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostJourneysGetJourneyResponse>>;
  public journeysGetJourneyPost(
    generated?: PostJourneysGetJourneyRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostJourneysGetJourneyResponse>>;
  public journeysGetJourneyPost(
    generated?: PostJourneysGetJourneyRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/journeys/get-journey`;
    return this.httpClient.request<PostJourneysGetJourneyResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 処理名： チェックイン検索&lt;br&gt; リクエストから受け取った検索項目を基にDxAPI、iCASに接続し、CPRを検索する。&lt;br&gt; CPRが検索できた場合、チェックイン対象となるjourney(スルーチェックイン可能なCPR複数を1つにまとめたデータ)を識別し、国内線/国際線の分類からチェックイン先システムを判定し返却する。&lt;br&gt; チェックイン先システムがDxAPIであった場合、チェックイン対象journeyのチェックイン可否を判定し、可であればチェックイン対象のjourneyIDも併せて返却する。不可であれば不可理由を返却する。&lt;br&gt; また、チェックイン先システムが国内線ASW(able-D)であった場合、連携時に必要になるパラメータ情報を暗号化し、併せて返却する。  ### 【アクセス情報】&lt;br&gt; 外部からの呼び出しは、以下のURLとする。   | 環境 | URL |  | :--- | :--- |  | 本番 | https://space.ana.co.jp/aswbe-checkin/api/v1/journeys/search-journey |  | ステージング |https://stg.test.space.ana.co.jp/stg1/aswbe-checkin/api/v1/journeys/search-journey&lt;br&gt;https://stg.test.space.ana.co.jp/stg2/aswbe-checkin/api/v1/journeys/search-journey |  | 開発 | https://dev.test.space.ana.co.jp/dev1/aswbe-checkin/api/v1/journeys/search-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev2/aswbe-checkin/api/v1/journeys/search-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev3/aswbe-checkin/api/v1/journeys/search-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev4/aswbe-checkin/api/v1/journeys/search-journey&lt;br&gt;https://dev.test.space.ana.co.jp/dev5/aswbe-checkin/api/v1/journeys/search-journey |  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. リクエスト項目のバリデーションチェックを行う。   |No|エラー条件|   |---:|:---|   |1|予約番号検索かつ、予約番号がリクエスト項目に存在しない|   |2|航空券番号検索かつ、航空券番号がリクエスト項目に存在しない|   |3|予約番号検索もしくは航空券番号検索かつ、搭乗者名と搭乗者姓の合計桁数が56桁以上である|  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. AMC会員番号検索の場合、以下の処理を行う。   1.  呼び出し元より渡されたアクセストークンを復号し、トークン内に含まれるuuidを基に、ASWDB(Tx)からログイン中の会員情報を取得する。&lt;br&gt;   以下の条件のいずれかに合致する場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。&lt;br&gt;   |No|条件|   |---:|:---|   |1|パーソナライズ情報のログインステータスがリアルログイン以外である|   |2|パーソナライズ情報から会員番号を取得できない|  1. DxAPIに接続し、journeyを検索する。  1. 以下の内容にて、DxAPIでチェックイン取り扱い可能なjourneyを求める。   1. 振替が発生している場合、振替前のセグメントを持つjourneyを処理対象から除外する。   1. 同一のセグメントを持つ複数のjourneyが存在した場合、以下の処理を行う。     1. 往路のセグメントのみ、または復路のセグメントのみを持つjourneyを処理対象から除外する。     1. 空席待ち等の処理対象外であるブッキングステータスを持つjourneyを処理対象から除外する。   1. 出発済の便を処理対象から除外する。   1. 同一予約番号のjourneyをマージする。   1. NHグループ運航便の1便目の出発日時が最も早いjourneyを識別する。&lt;br&gt;   ※AMC会員番号検索の場合、グループPNRは除外する。除外した結果journeyが0件となった場合、iCAS呼び出し処理へスキップする。&lt;br&gt;   最も早いNHグループ運航便が同一日時で複数存在する場合、HTTPステータスコード:400を返却する。   1. 予約(マージした状態のjourney)に国内線が含まれる場合、DxAPIでチェックイン取り扱い可能なjourneyなしとする。   1. 予約(マージした状態のjourney)の1便目がAltea他社運航便かつ、検索対象の搭乗者が未チェックインの場合、HTTPステータスコード:400を返却する。   1. マージ前のNHグループ運航便が含まれるjourneyをチェックイン対象のjourneyとする。  1. チェックイン対象のjourneyが求められた場合、チェックイン可否を判定する。&lt;br&gt; 下記いずれかの条件に合致した場合、チェックイン不可とみなし、エラーをレスポンス項目に設定し、HTTPステータスコード:400を返却する。    |No|条件|   |---:|:---|   |1|予約番号検索で、グループPNRが検索された|   |2|チェックイン対象journeyの1便目のチェックイン可否について、検索対象の搭乗者のDxAPIのチェックイン不可理由がチェックイン検索エラー理由に合致した&lt;br&gt;※AMC会員番号検索の場合、ログイン会員を検索対象の搭乗者とする|   |3|チェックイン対象journeyの1便目について、Flight Acceptance StatusがNot Open&lt;br&gt;またはFlight Acceptance Status Timing Ruleの設定のチェックイン可能開始時間より現在時刻が前|   |4|チェックイン対象journeyの全便について、検索対象の搭乗者が発券済みでない|   |5|チェックイン対象journeyの全便について、全搭乗者が搭乗済み|  1. チェックイン対象のjourneyが存在しない場合、iCASに接続し、CPRを検索するため、iCAS呼び出し処理を行う。&lt;br&gt; CPRが検索できなかった場合、その旨のエラーをレスポンス項目として設定し、HTTPステータスコード:400を返却する。  1. DxAPI、もしくはiCASから検索したCPRを基に、チェックイン先システムを判定する。   |No|条件|チェックイン先システム|   |---:|:---|:---|   |1|DxAPIのjourneyがあり、日本国内線が含まれていない|SPACEシステム（SPACE）|   |2|上記以外でiCASから国内単独旅程である旨のエラーが返却されていない|iCAS（国際線ASW(iCAS)）|   |3|iCASから国内単独旅程である旨のエラーが返却された|able-D（国内線ASW(able-D)）|  1. チェックイン先システムが国内線ASW(able-D)の場合、連携時に必要になる検索条件や遷移元情報を結合し、暗号化する。  1. HTTPステータスコード:200を返却する。  # 3. データ更新内容 - なし  # 4. 特記事項 - なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public journeysSearchJourneyPost(
    generated?: PostJourneysSearchJourneyRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostJourneysSearchJourneyResponse>;
  public journeysSearchJourneyPost(
    generated?: PostJourneysSearchJourneyRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostJourneysSearchJourneyResponse>>;
  public journeysSearchJourneyPost(
    generated?: PostJourneysSearchJourneyRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostJourneysSearchJourneyResponse>>;
  public journeysSearchJourneyPost(
    generated?: PostJourneysSearchJourneyRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/journeys/search-journey`;
    return this.httpClient.request<PostJourneysSearchJourneyResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 処理名： チェックイン搭乗者情報更新&lt;br&gt; リクエストから受け取った搭乗者情報（パスポート情報、FFP情報、連絡先情報、入国関連情報）をもとにDxAPIおよびAltea Web Serviceに接続し、搭乗者情報の登録・更新を行う。&lt;br&gt; ※入国関連情報にはVISA情報・グリーンカード情報・Redress Number・KnownTravelerNumber・居住国または地区のコード・滞在先情報が含まれる。&lt;br&gt;  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. 以下の処理にてDxAPIを呼び出し、最新のjourneyを取得する。 リクエストから受け取ったjourneyIDをDxAPIに渡し、journeyを検索する。&lt;br&gt; 検索結果が取得できた場合、出発済みの便をjourneyから除外する。&lt;br&gt; DxAPIのレスポンスの結果がエラー、検索結果が0件の場合、または出発済みの便を除外した結果journey内の便が0件となった場合、HTTPステータス400を返却する。  1. journeyをもとにDxAPIを呼び出し、PNR情報を取得する。&lt;br&gt; DxAPIのレスポンスの結果がエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。  1. 以下の処理にて Altea web service(DCSIDC_CPRIdentification)を呼び出し、CPR情報を取得する。 journey内のorderIdをAltea web serviceに渡し、CPR情報を検索する。&lt;br&gt; Altea web serviceのレスポンスの結果がエラーの場合、HTTPステータス500を返却する。  1. リクエスト項目のバリデーションチェックを行う。 以下のいずれかの条件に合致した場合、HTTPステータス400を返却する。 |No|条件|備考| |---:|:---|:---| |1|搭乗者名と搭乗者ミドルネームと搭乗者姓の合計桁数が61桁以上である|| |2|リクエスト情報の連絡先情報のSMS電話番号の値を共通部品「入力チェック部品(API)」(G03-501)を利用してチェックし結果がエラーである|SMSのチェックは国または地区番号が日本の場合に実施| |3|リクエスト情報の連絡先情報に設定されている緊急連絡先の電話番号の値を共通部品「入力チェック部品(API)」(G03-501)を利用してチェックし結果がエラーである|SMS送信の電話番号の形式チェックは実施しない| |4|FFP情報のキャリアコードが「NH」かつ、カード番号が10桁の数字以外である|| |5|FFP情報のキャリアコードが「NH」かつ、カード番号の上9桁の数字を7で割った余りに1を足した値が、下1桁と一致しない|| |6|リクエスト情報の性別が空かつjourneyの搭乗者種別が幼児以外である、またはリクエスト情報の性別が空かつjourneyのパスポート情報の性別がunspecified（PNRのXI、UIに相当）以外である|| |7|リクエスト情報の性別がありかつリクエスト情報の性別の値がASWDB（マスタ）に存在しない|| |8|適用国が「米国」かつ、ビザ番号の桁数が8桁の英数字以外である|| |9|適用国が「米国」以外かつ、ビザ番号の桁数が1～20桁の英数字以外である|| |10|1人の搭乗者に対して滞在先情報が2件以上設定されている|| |11|パスポート情報の発行国の値がASWDB（マスタ）に存在しない|| |12|リクエスト情報のVISA情報とグリーンカード情報両方に値が設定されている|| |13|アメリカ着またはカナダ着のセグメントを1つでも含むかつ、居住国情報が設定されていない|| |14|アメリカ着のセグメントを1つでも含むかつ、滞在先が設定されていない|| |15|適用国が「米国」以外で、滞在先情報が設定されている|| |16|適用国が「米国」以外で、グリーンカード情報が設定されている|| |17|ビザ番号が空かつビザの有効期限あり、またはビザ番号が空かつビザの無期限指定ありである|| |18|ビザ番号がありかつビザの有効期限なしかつビザの無期限指定なしである|| |19|1人の搭乗者に対してビザ情報が2件以上設定されている|| |20|グリーンカード番号が空かつグリーンカードの有効期限あり、またはグリーンカード番号が空かつグリーンカードの無期限指定ありである|| |21|グリーンカード番号がありかつグリーンカードの有効期限なしかつグリーンカードの無期限指定なしである|| |22|1人の搭乗者に対してグリーンカード情報が2件以上設定されている|| |23|1人の搭乗者に対してメールアドレスが2件以上設定されている|| |24|1人の搭乗者に対して電話番号が2件以上設定されている|| |25|1人の搭乗者に対して緊急連絡先が2件以上設定されている|| |26|搭乗者メール情報が設定されていない|| |27|アメリカ着のセグメントを1つでも含むかつSMS電話情報、緊急連絡先のいずれかが設定されていない&lt;br&gt;※CPR情報で、対象の搭乗者に対し複数の値が登録されている項目については当該チェックを行わない|| |28|ビザ・グリーンカードの有効期限がミュンヘン国際空港の現地日付～その日付+設定ファイルより取得したビザ・グリーンカード・パスポートの有効期限の最大年の間に含まれていない|| |29|パスポートの有効期限が基準日付(サイトのローカル日付)～基準日付+設定ファイルより取得したビザ・グリーンカード・パスポートの有効期限の最大年の間に含まれていない|| |30|アメリカ着のセグメントを含まないかつ、緊急連絡先が設定されている||  1. 以下の処理にてjourneyから、搭乗者の情報登録・更新可否判定を行う。 下記いずれかの条件に合致した場合、登録・更新不可とし、不可理由に対応するメッセージIDをレスポンス項目として設定し、HTTPステータス400を返却する。iAPI対象国に関しては設定ファイルから取得する。&lt;br&gt; |No|条件|備考| |---:|:---|:---| |1|1便目の受付ステータスがopenedでない|| |2|journeyのFFP情報が1件かつ、リクエスト情報のFFP情報が空である|| |3|journeyのFFP情報が2件以上かつ、リクエスト情報のFFP情報が空以外である|| |4|FFP情報のキャリアコードとjourneyのFFPキャリアコードが一致しないかつ、FFP情報のキャリアコードの値がASWDB（マスタ）に存在しない|| |5|FFP情報のキャリアコードと会員番号がjourneyと合致せず、設定ファイルに存在する登録不可FFP情報のキャリアコードと一致する|FFP情報のキャリアコードと会員番号がjourneyから変更ない場合は更新不可にしない| |6|FFP情報のキャリアコードと会員番号の組合せが他の搭乗者と重複している|| |7|FFP情報のキャリアコードがNHで、会員番号及び姓名でMindsに存在有無を確認し、存在しない|| |8|Regulatory情報のキャリアコードNHであるパスポート情報が1件または、0件かつCPR情報の生年月日が存在するかつ、リクエスト情報のパスポート情報が空である|| |9|Regulatory情報のキャリアコードNHであるパスポート情報が2件以上かつ、リクエスト情報のパスポート情報が空以外である|| |10|1人の搭乗者に対してRegulatory情報のキャリアコードNHであるパスポート情報が2件以上かつ、iAPI対象国を旅程に含む|| |11|Regulatory情報のVISA情報が2件以上かつ、リクエスト情報のVISA情報が空以外である|| |12|Regulatory情報のキャリアコードNHであるグリーンカード情報が2件以上かつ、リクエスト情報のグリーンカード情報が空以外である|| |13|Regulatory情報のキャリアコードNHである滞在先情報が2件以上かつ、リクエスト情報の滞在先情報が空以外である|| |14|Regulatory情報のキャリアコードNHであるRedress Numberが空以外かつ、リクエスト情報のRedress Numberが空以外である|| |15|Regulatory情報のキャリアコードNHであるKnown Traveler Numberが空以外かつ、リクエスト情報のKnown Traveler Numberが空以外である|| |16|CPR情報の電話番号が2件以上かつ、リクエスト情報の電話番号が空以外である|| |17|CPR情報の緊急連絡先が2件以上かつ、リクエスト情報の緊急連絡先が空以外である|| |18|journeyのチェックイン状況がチェックイン済みかつリクエスト情報のパスポート情報の国籍が空以外である|| |19|journeyのチェックイン状況が未チェックインかつリクエスト情報のパスポート情報の国籍が空である|| |20|搭乗者メール(SKメール)が2件以上存在するかつ、リクエスト情報の搭乗者メールアドレスが搭乗者メール(SKメール)に含まれない場合|| |21|日本国内旅程以外かつ、journeyの搭乗者種別が小児または幼児かつ、リクエスト情報のパスポート情報の生年月日が空でない|| |22|日本国内旅程以外かつ、journeyの搭乗者種別が小児または幼児以外かつ、Regulatory情報のキャリアコードNHであるパスポート情報が2件未満であるかつ、リクエスト情報のパスポート情報の生年月日が空である|| |23|日本国内旅程以外かつ、journeyの搭乗者種別が小児または幼児かつ、Regulatory情報のキャリアコードNHであるパスポート情報の生年月日が空であるかつ、CPR情報の生年月日が空であるかつ、NAMEエレメントの生年月日が空である||  1. 以下の処理にてチェックイン搭乗者情報を登録・更新する。   1. 以下のいずれかの条件に一致する場合、Altea Web Service(DCSCPR_EditCPR)を呼び出し搭乗者のパスポート情報・入国関連情報を登録・更新する。&lt;br&gt;   登録・更新に予期せぬエラーが発生した場合は、HTTPステータス500を返却する。&lt;br&gt;     |No|条件|備考|     |---:|:---|:---|     |1|リクエスト情報のパスポート情報・入国関連情報がRegulatory情報から変更がある|Regulatory情報のパスポート情報等が2件以上、またはリクエスト情報の当該情報が空の場合に、当該ドキュメントは更新しない|     |2|iAPI対象国のセグメントを含む|リクエスト情報のパスポート情報・入国関連情報がRegulatory情報から変更がない場合はパスポート情報のみ更新する|    1. リクエスト情報のFFP情報がjourneyから変更がある場合、DxAPIを呼び出し、搭乗者のFFP情報を登録・更新する。&lt;br&gt;   登録・更新に予期せぬエラーが発生した場合は、HTTPステータス500を返却する。&lt;br&gt;    1. Altea web service(DCSCPR_EditCPR)を呼び出し搭乗者の連絡先情報のSMS電話情報(CTCM)の削除・登録・更新(削除してから登録)を行う。&lt;br&gt;   削除・登録・更新に予期せぬエラーが発生した場合は、HTTPステータス500を返却する。       1. 以下のいずれかの条件に一致する場合、対応する処理を行う。         1. リクエスト情報のSMS電話情報が空、かつCPR情報にキャリアコードNHであるSMS電話情報が1件だけ存在する場合、キャリアコードNHであるSMS電話情報を削除する。         1. リクエスト情報のSMS電話情報が空以外、かつCPR情報にキャリアコードNHであるSMS電話情報が存在しない場合、SMS電話情報を登録する。         1. リクエスト情報のSMS電話情報が空以外、かつCPR情報にキャリアコードNHであるSMS電話情報が存在する、かつそのSMS電話情報にリクエストされた値と同じ情報が存在しない場合、キャリアコードNHであるSMS電話情報を削除したあとにSMS電話情報を登録する。   1. Altea web service(DCSCPR_EditCPR)を呼び出し搭乗者の連絡先情報の緊急連絡先(PCTC)の登録・更新を行う。&lt;br&gt;   登録・更新に予期せぬエラーが発生した場合は、HTTPステータス500を返却する。       1. 以下のいずれかの条件に一致する場合、対応する処理を行う。         1. リクエスト情報の緊急連絡先が空以外、かつCPR情報にキャリアコードNHである緊急連絡先が存在しない場合、緊急連絡先を登録する。         1. リクエスト情報の緊急連絡先が空以外、かつCPR情報にキャリアコードNHである緊急連絡先が存在する、かつその緊急連絡先にリクエストされた値と同じ情報が存在しない場合、緊急連絡先を更新する。    1. Altea web service(DCSCPR_EditCPR)を呼び出し、搭乗者のメールアドレスの削除・登録・更新（削除してから登録）を行う。&lt;br&gt;   登録・更新に予期せぬエラーが発生した場合は、HTTPステータス500を返却する。&lt;br&gt;   ※以下のいずれの条件にも当てはまらない場合は変更なしとし処理を行わない。       1. 直営PNRである場合、以下の処理を行う。         1. キャリアコードNHのSSR CTCEについて、以下のいずれかの条件に一致する場合、対応する処理を行う。           1. CPR情報に搭乗者メールアドレス(SKメール)と同じ値であるSSR CTCEが存在しない、かつリクエスト情報の搭乗者メールアドレスと同じ値のSSR CTCEが存在しない場合、キャリアコードNHのSSR CTCEを1件登録する。           1. CPR情報に搭乗者メールアドレス(SKメール)と同じ値であるSSR CTCEが存在する、かつリクエスト情報の搭乗者メールアドレスと同じ値のSSR CTCEが存在しない場合、キャリアコードNH、かつSKメールと同じ値のSSR CTCEを全て削除したあとにキャリアコードNHのSSR CTCEを1件登録する。           1. リクエスト情報の搭乗者メールアドレスと同じ値のSSR CTCEが複数存在する場合、リクエスト情報の搭乗者メールアドレスと同じ値のSSR CTCEを重複削除する。         1. キャリアコードNH以外のSSR CTCEについて、以下の条件に一致する場合、対応する処理を行う。           1. CPR情報に搭乗者メールアドレス(SKメール)と同じ値であるSSR CTCEが存在する場合、他キャリア毎に、SKメールと同じ値のSSR CTCEを全て削除したあとにそのキャリアコードのSSR CTCEを削除した件数分登録する。       1. 直営外PNRである、かつリクエスト情報の搭乗者メールアドレスと同じ値のSSR CTCEが存在しない場合、キャリアコードNHのSSR CTCEを1件登録する。       1. リクエスト情報の搭乗者メールアドレスがCPR情報の搭乗者メールアドレス(SKメール)から変更がある場合、以下の処理を行う。&lt;br&gt;       ただし、CPR情報から、1人の搭乗者で搭乗者メールアドレス(SKメール)が2件以上取得できた場合は以下の処理を行わない。         1. CPR情報が空以外の場合、Altea web service(DCSCPR_EditCPR)を呼び出し、搭乗者メールアドレス(SKメール)を削除する。&lt;br&gt;         1. Altea web service(DCSCPR_EditCPR)を呼び出し、搭乗者メールアドレス(SKメール)を登録する。&lt;br&gt;  1. 以下の処理にてDxAPIを呼び出し、RegulatoryCheck結果を確認する。&lt;br&gt;   1. DxAPIを呼び出しRegulatoryCheck結果がOKで返却される場合、HTTPステータス201を返却する。&lt;br&gt;   1. RegulatoryCheck結果がNGで返却される場合、HTTPステータス400を返却する。&lt;br&gt;  # 3. データ更新内容   1. CPR     |更新フィールド|更新内容|データ取得元|条件等|     |:---|:---|:---|:---|     |SSR|パスポート情報&lt;br&gt;コード : DOCS&lt;br&gt;フリーテキスト :P &lt;発行国コード&gt;&lt;パスポート番号&gt;&lt;国籍&gt;&lt;生年月日&gt;&lt;性別&gt;&lt;パスポート有効期限&gt;&lt;性&gt;&lt;名&gt;&lt;ミドルネーム&gt;|呼び出し元より渡された情報|iAPI対象国のセグメントを含む場合&lt;br&gt;iAPI対象国のセグメントを含まないかつ、更新内容に記載の項目の入力値入国関連情報の入力値の変更がある場合|     |SSR|居住国&lt;br&gt;コード : DOCA&lt;br&gt;フリーテキスト :R &lt;国コード&gt; |呼び出し元より渡された情報|iAPI対象国のセグメントを含む場合&lt;br&gt;iAPI対象国のセグメントを含まないかつ、更新内容に記載の項目の入力値入国関連情報の入力値の変更がある場合|     |SSR|VISA&lt;br&gt;コード : DOCO&lt;br&gt;フリーテキスト :V &lt;ビザ番号&gt;&lt;ドキュメント有効期限&gt;&lt;適用国&gt;&lt;br&gt;※「ビザ有効期限なし」を選択した場合、有効期限を2099年12月31日で登録する。&lt;br&gt;※適用国は、リクエストで受け取った適用国情報を基に設定する。|呼び出し元より渡された情報|iAPI対象国のセグメントを含む場合&lt;br&gt;iAPI対象国のセグメントを含まないかつ、更新内容に記載の項目の入力値入国関連情報の入力値の変更がある場合|     |SSR|グリーンカード&lt;br&gt;コード : DOCS&lt;br&gt;フリーテキスト :C &lt;ドキュメント番号&gt;&lt;ドキュメント有効期限&gt;&lt;br&gt;※「グリーンカード有効期限なし」を選択した場合、有効期限を2099年12月31日で登録する。|呼び出し元より渡された情報|iAPI対象国のセグメントを含む場合&lt;br&gt;iAPI対象国のセグメントを含まないかつ、更新内容に記載の項目の入力値入国関連情報の入力値の変更がある場合|     |SSR|滞在先&lt;br&gt;コード : DOCA&lt;br&gt;フリーテキスト :D &lt;国コード&gt;&lt;住所&gt;&lt;都市名&gt;&lt;州名&gt;&lt;ZIPコード&gt;|呼び出し元より渡された情報|iAPI対象国のセグメントを含む場合&lt;br&gt;iAPI対象国のセグメントを含まないかつ、更新内容に記載の項目の入力値入国関連情報の入力値の変更がある場合&lt;br&gt;滞在/トランジット選択が「トランジット」である場合、以下の値で登録。&lt;br&gt;  (a) 住所またはホテル名：“TRANSIT”&lt;br&gt;  (b) 都市名：“TRANSIT”&lt;br&gt;  (c) 州名：“NY”(ニューヨーク)&lt;br&gt;  (d) 郵便番号：“99999”&lt;br&gt;  (e) 国：“USA”(アメリカ)|     |SSR|Redress Number&lt;br&gt;コード : DOCO&lt;br&gt;フリーテキスト :R &lt;ドキュメント番号&gt;&lt;適用国&gt;※適用国をUSで登録|呼び出し元より渡された情報|iAPI対象国のセグメントを含む場合&lt;br&gt;iAPI対象国のセグメントを含まないかつ、更新内容に記載の項目の入力値入国関連情報の入力値の変更がある場合|     |SSR|Known Traveler Number&lt;br&gt;コード : DOCO&lt;br&gt;フリーテキスト :K &lt;ドキュメント番号&gt;&lt;適用国&gt; ※適用国をUSで登録|呼び出し元より渡された情報|iAPI対象国のセグメントを含む場合&lt;br&gt;iAPI対象国のセグメントを含まないかつ、更新内容に記載の項目の入力値入国関連情報の入力値の変更がある場合|     |SSR|FFP会員番号&lt;br&gt;コード : FQTS&lt;br&gt;フリーテキスト :&lt;FFPキャリアコード&gt;&lt;FFP会員番号&gt;|呼び出し元より渡された情報|ログイン済、かつログインユーザ名が搭乗者名と一致する場合またはFFPキャリアコードが「NH」の場合のみ登録する|     |SSR|FFP会員番号&lt;br&gt;コード : FQTV&lt;br&gt;フリーテキスト :&lt;FFPキャリアコード&gt;&lt;FFP会員番号&gt;|呼び出し元より渡された情報||     |SSR|SMS送信用電話番号&lt;br&gt;コード : CTCM&lt;br&gt;フリーテキスト :&lt;電話番号&gt;　&lt;br&gt;(ssrCode&#x3D;CTCM,numberInParty&#x3D;1,serviceType&#x3D;S,serviceFreeText&#x3D;＜国番号＞＋＜搭乗者電話番号＞+＜言語コード＞として登録する)&lt;br&gt;※電話番号の国番号が日本、かつ電話番号の先頭が0の場合、電話番号の先頭の0を取り除く。 |呼び出し元より渡された情報||     |SK|搭乗者メールアドレス&lt;br&gt;コード : MAIL&lt;br&gt;フリーテキスト :&lt;メールアドレス&gt; (ssrCode&#x3D;MAIL,numberInParty&#x3D;1,serviceType&#x3D;K,serviceFreeText&#x3D;P＋＜メール言語コード＞＋T+＜搭乗者メールアドレス＞として登録する) |リクエストボディの搭乗者メールアドレス、リクエストボディの言語コードでASW(マスタ)からメール言語コードを取得する||     |SSR|米国送信用搭乗者メールアドレス&lt;br&gt;コード : CTCE&lt;br&gt;フリーテキスト :&lt;メールアドレス&gt;&lt;br&gt;(ssrCode&#x3D;CTCE,numberInParty&#x3D;1,serviceType&#x3D;S,serviceFreeText&#x3D;＜搭乗者メールアドレス＞＋＜メール言語コード＞として登録する)|リクエストボディの搭乗者メールアドレス、リクエストボディの言語コードでASW(マスタ)からメール言語コードを取得する||     |SSR|緊急連絡先&lt;br&gt;コード : PCTC&lt;br&gt;フリーテキスト :&lt;電話の持ち主&gt;+&lt;国番号&gt;+&lt;電話番号&gt;(surname&#x3D;&lt;電話の持ち主&gt;,phoneNumber&#x3D;&lt;電話番号&gt;,countryOfResidence&#x3D;&lt;国コード&gt;として登録する)&lt;br&gt;※電話番号の国番号が日本、かつ電話番号の先頭が0の場合、電話番号の先頭の0を取り除く。 |呼び出し元より渡された情報||  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public journeysUpdateTravelersPost(
    generated?: PostCheckinTravelersRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public journeysUpdateTravelersPost(
    generated?: PostCheckinTravelersRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public journeysUpdateTravelersPost(
    generated?: PostCheckinTravelersRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public journeysUpdateTravelersPost(
    generated?: PostCheckinTravelersRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/journeys/update-travelers`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： 空席待ち削除&lt;br&gt; リクエストから受け取ったjourneyIDをDxAPIに渡し、journeyを取得する。&lt;br&gt; 取得したjourneyから予約番号と搭乗者姓名を抽出し、抽出した予約番号と搭乗者姓名、リクエストから受け取ったセグメントIDに紐づくセグメント情報をプロセス層の空席待ち削除APIに渡し、journey内のすべての搭乗者に対して空席待ち削除を行う。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目を基にDxAPIを呼び出し、journeyを取得する。&lt;br&gt; DxAPIのレスポンスの結果がエラー、検索結果が0件の場合、HTTPステータス400を返却する。  1. 取得したjourneyをもとに、空席待ち削除可否判定を行う。&lt;br&gt;   1. 異なるPNRの同行者が追加されている場合、空席待ち削除不可とし、HTTPステータスコード400を返却する。  1. 取得したjourneyから予約番号と搭乗者姓名を抽出し、journeyを検索する。&lt;br&gt; DxAPIのレスポンスの結果がエラー、検索結果が0件の場合、HTTPステータス500を返却する。  1. リクエストから受け取ったセグメントIDおよび取得したjourneyを基に、空席待ち削除対象のセグメントであるか判定を行う。&lt;br&gt; Altea空港出発ではない、またはNHグループ運航・販売ではない場合、空席待ち削除対象外のセグメントとし、HTTPステータス400を返却する。&lt;br&gt; ※セグメントのableハンドル判定がfalseの場合、Altea空港出発のセグメントとする  1. 取得したjourneyから予約番号と搭乗者姓名を抽出し、抽出した予約番号と搭乗者姓名、リクエストから受け取ったセグメントIDに紐づくセグメント情報をプロセス層の空席待ち削除APIに渡し、journey内のすべての搭乗者に対して空席待ち削除を行う。&lt;br&gt;   1. プロセス層の空席待ち削除APIから下記の旨のワーニングが返却された場合、HTTPステータス400を返却する。&lt;br&gt;      |No|ワーニング内容|     |---:|:---|     |1|リクエスト情報にAcceptance StatusがOpenでもFinalizedでもないセグメントが存在する|     |2|リクエスト情報にAcceptance StatusがFinalizedであるセグメントが存在する|     |3|リクエスト情報にスタンバイの種類がStandby Transfer、CJ Standbyのいずれでもないセグメントが存在する|    1. 上記以外の場合、プロセス層の空席待ち削除APIからの返却値をそのまま返却する。  # 3. データ更新内容   1. CPR   |更新フィールド|更新内容|データ取得元|条件等|   |:---|:---|:---|:---|   |空席待ち便|空席待ち便を削除する|呼び出し元より渡された情報||    1. PNR   |更新フィールド|更新内容|データ取得元|条件等|   |:---|:---|:---|:---|   |空席待ち便|空席待ち便を削除する|呼び出し元より渡された情報||  # 4. 特記事項 - プロセス層の空席待ち削除APIにて、スタンバイセグメントの種類を判定し、それに応じてDxAPIとCM Open APIを使い分けて空席待ち削除を行う。
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public standbyCancelPost(
    generated?: PostStandbyCancelRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public standbyCancelPost(
    generated?: PostStandbyCancelRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public standbyCancelPost(
    generated?: PostStandbyCancelRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public standbyCancelPost(
    generated?: PostStandbyCancelRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/standby/cancel`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： 空席待ちエントリー確定&lt;br&gt; リクエストから受け取ったjourneyIDをDxAPIに渡し、CPR情報を取得する。&lt;br&gt; また、空席待ち便を含むjourneyを検索するため、取得したCPR情報をもとにDxAPIを呼び出し、journeyを検索する。&lt;br&gt; 取得したCPR情報をもとにエクスペリエンス層のPNR情報取得APIを呼び出し、PNR情報を取得する。&lt;br&gt; リクエストから受け取った空席待ち前のオリジナル便（以降、ORI便）の情報、取得したCPR情報をAltea Web Serviceに渡し、Onload Statusを取得する。&lt;br&gt; 取得したCPR情報、journey情報、PNR情報、Onload Statusを基にChange Journey可能であるかチェックを行い、可能である場合はCM Open APIに接続して空席待ちエントリーを行う。&lt;br&gt; PNR内の全ての搭乗者が空席待ちエントリーに成功した場合、PLUSを通じてメール送信を行う。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエストから受け取ったjourneyIDをDxAPIに渡し、CPR情報を取得する。&lt;br&gt; 検索結果が取得できた場合、Standby Transferである便をCPR情報から除外する。&lt;br&gt; レスポンスの結果がエラー、検索結果が0件の場合、またはStandby Transferの便を除外した結果CPR情報内の便が0件となった場合、HTTPステータス400を返却する。  1. 取得したCPR情報をもとにChange Journey可能かどうかチェックを行う。&lt;br&gt; 以下のいずれかの条件に合致する場合、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|操作時刻が対象ORI便の出発日当日0時を過ぎていない||   |2|同行者追加済みである||   |3|1人でも手荷物受託済みの搭乗者が存在する||   |4|1人でも搭乗ゲート通過済みの搭乗者が存在する||   |5|ORI便で搭乗者のキャビンクラスが混在している||   |6|ORI便に対して搭乗者がHigh Priority制限を保持し、かつ以下のいずれかに該当する&lt;br&gt;1. Acceptance comment(ACC)が登録されている&lt;br&gt;2. Next comment(NXT)が登録されている||   |7|グループPNRである||   |8|journey内に3便以上の旅程が存在する||   |9|ORI便の前に未搭乗の搭乗者が存在するセグメントが存在する||   |10|日本国内線以外が含まれる||   |11|ORI便がHow about this flightケースで提案された便で確定していない&lt;br&gt;※ASWDB(tx)の振替オプション情報からHow about this flightケースを判断する|  1. 取得したCPR情報をもとにDxAPIを呼び出し、journeyを検索する。&lt;br&gt; レスポンスの結果がエラー、検索結果が0件の場合、HTTPステータス500を返却する。  1. 取得したjourney情報をもとにChange Journey可能かどうかチェックを行う。&lt;br&gt; 以下のいずれかの条件に合致する場合、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|メールアドレス（SK MAIL）未登録の搭乗者が存在する||   |2|セグメント情報の1便目が未チェックインの搭乗者が一人でも存在する||   |3|Change Journey不可のSSRとしてASWDB(マスタ)に保持しているSSRが存在する||   |4|ASWDB(マスタ)で管理する提携航空会社以外とのコードシェア便が含まれる||   |5|旅程にAltea移行前（able）空港が存在する||   |6|同一出発日、同一区間、同一便名で、キャビンクラスが異なるORI便とHL便を保持している搭乗者が1人でも存在する||  1. 取得したCPR情報をもとにエクスペリエンス層のPNR情報取得APIを呼び出し、PNR情報を取得する。&lt;br&gt; レスポンスの結果がエラー、検索結果が0件の場合、HTTPステータス500を返却する。  1. 取得したPNR情報をもとにChange Journey可能かどうかチェックを行う。&lt;br&gt; 以下のいずれかの条件に合致する場合、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|旅程操作不可PNRと判断される、または原券の運賃が変更不可型かつDynamic Waiverが適用されていない||   |2|航空券の支払方法にANA SKYコインが含まれ、かつANAがANA SKYコインの払戻機能をOFFにしている||   |3|航空券の支払い方法がGMOP(コンビニエンスストア支払/インターネットバンキング/銀行振込/Pay-easy)で、ログイン中の会員がPNRの搭乗者に存在しない||   |4|不正なTicket Designatorと判断される||   |5|PNR内にARNKセグメントが含まれる||   |6|特典PNRである||   |7|NHプレートチケット(205券)以外で発券している||   |8|PNR responsible officeがNH3である||   |9|NDC PNRで、マーチャントがNH以外で、旅程内の第一便が搭乗済みでない||  1. リクエストから受け取ったORI便の情報、取得したCPR情報をAltea Web Serviceに渡し、Onload Statusを取得する。&lt;br&gt; レスポンスの結果がエラーの場合、ワーニングを返却するのみとし、処理は継続する。  1. 取得したOnload StatusをもとにChange Journey可能かどうかチェックを行う。&lt;br&gt; 以下のいずれかの条件に合致する場合、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|ORI便のOnload StatusがFinalizedである||  1. リクエストから受け取った空席待ちする便情報をCM Open APIに渡し、空席待ちエントリーを行う。&lt;br&gt; 変更前の便に付随していたSSR/SKが変更後の便に付け替えができなかった旨のワーニングが返却された場合、ワーニングを返却するのみとし、処理は継続する。&lt;br&gt; レスポンスの結果がエラーの場合、HTTPステータス400を返却する。  1. 取得したjourney情報およびPNR情報から空席待ちエントリー完了メール送信用パラメータを生成してPLUSに渡し、メールを送信する。&lt;br&gt; レスポンスの結果がエラーの場合、ワーニングを返却するのみとし、処理は継続する。  1. HTTPステータス201を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 CM Open API呼び出し時のリクエスト設定により、空席待ちエントリーは全件成功または全件失敗のいずれかとなる。
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public standbyCompleteEntryPost(
    generated?: PostStandbyCompleteEntryRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public standbyCompleteEntryPost(
    generated?: PostStandbyCompleteEntryRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public standbyCompleteEntryPost(
    generated?: PostStandbyCompleteEntryRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public standbyCompleteEntryPost(
    generated?: PostStandbyCompleteEntryRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/standby/complete-entry`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： 空席待ち候補便照会&lt;br&gt; リクエストから受け取った予約番号と搭乗者姓名をDxAPIに渡し、journeyを検索する。&lt;br&gt; リクエストから受け取った予約番号と搭乗者姓名、セグメント情報をCM Open APIに渡し、搭乗者検索を行うことで、空席待ち候補便照会に利用するセグメント情報を取得する。&lt;br&gt; 取得したjourney情報、セグメント情報をCM Open APIに渡し、空席待ち候補便照会を行う。&lt;br&gt; 取得した情報をもとに各種の業務的判定処理を行い、判定結果および取得した情報を返却する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエストから受け取った予約番号と搭乗者姓名をDxAPIに渡してjourneyを検索し、リクエストのセグメント情報の発着空港および出発日と一致するセグメントを含むjourneyを取得する。&lt;br&gt; DxAPIのレスポンスの結果がエラー、もしくは検索結果が0件の場合、HTTPステータス400を返却する。  1. リクエストから受け取った予約番号と搭乗者姓名、セグメント情報をCM Open APIに渡し、搭乗者検索を行うことで、空席待ち候補便照会に利用するセグメント情報を取得する。&lt;br&gt; CM Open APIのレスポンスの結果がエラー、もしくは検索結果が0件の場合、HTTPステータス400を返却する。  1. 取得したjourney情報、セグメント情報をCM Open APIに渡し、空席待ち候補便照会を行う。&lt;br&gt; CM Open APIのレスポンスの結果がエラー、もしくは取得結果が0件の場合、HTTPステータス400を返却する。  1. 取得した候補便から、以下の条件をすべて満たす候補便を抽出し、返却対象の候補便とする。&lt;br&gt; 抽出した結果、返却対象の候補便が0件となった場合、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|airProductStatusがWAITLISTである、または取得したjourney情報を基にスタンバイ済みと判定された||   |2|出発地、および目的地がリクエストから受け取った便(以降、ORI便とする)と同一である|マルチ空港は同一とみなさない|  1. 発着APIを呼び出し、返却対象の候補便とORI便の最新運航情報を取得する。&lt;br&gt;   発着APIのレスポンスの結果がエラー、もしくは取得結果が0件の場合でも、ワーニングを返却するのみとし、処理は継続する。  1. 返却対象の候補便から、以下のいずれかの条件を満たす候補便を除外する。&lt;br&gt; 除外した結果、返却対象の候補便が0件となった場合、HTTPステータス400を返却する。    |No|条件|備考|   |---:|:---|:---|   |1|最新運航情報の取得結果が欠航である||   |2|出発時間が、現在時刻+設定ファイルに定義した空席待ち便表示対象時間から、ORI便の出発時間までの範囲外である|空席待ち候補便とORI便の出発時刻は最新出発予定時刻(ETD)を比較する。ETDが存在しない場合は計画出発予定時刻(STD)を利用して比較する。|  1. HTTPステータス200を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public standbyGetAlternativeOffersPost(
    generated?: PostStandbyGetAlternativeOffersRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostStandbyGetAlternativeOffersResponse>;
  public standbyGetAlternativeOffersPost(
    generated?: PostStandbyGetAlternativeOffersRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostStandbyGetAlternativeOffersResponse>>;
  public standbyGetAlternativeOffersPost(
    generated?: PostStandbyGetAlternativeOffersRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostStandbyGetAlternativeOffersResponse>>;
  public standbyGetAlternativeOffersPost(
    generated?: PostStandbyGetAlternativeOffersRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/standby/get-alternative-offers`;
    return this.httpClient.request<PostStandbyGetAlternativeOffersResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 処理名： 空席待ち便選択&lt;br&gt; リクエスト情報をCM Open APIに渡し、空席待ち確認を行う。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト情報をCM Open APIに渡し、空席待ち確認を行う。&lt;br&gt; レスポンスの結果がエラーの場合、HTTPステータス400を返却し、以下の条件に合わせてエラーコードを返却する。    |No|条件|備考|   |---:|:---|:---|   |1|選択された空席待ち候補便が欠航になった||   |2|上記以外のエラー||  1. HTTPステータス201を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public standbySelectPost(
    generated?: PostStandbySelectRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public standbySelectPost(
    generated?: PostStandbySelectRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public standbySelectPost(
    generated?: PostStandbySelectRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public standbySelectPost(
    generated?: PostStandbySelectRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/standby/select`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 処理名： 空席待ち人数取得&lt;br&gt; リクエストから受け取った項目をもとにAltea Web Serviceに接続し、フライトの空席待ち人数を取得する。&lt;br&gt; また、フライトの情報をもとに、Onload StatusをAltea Web Serviceから、最新運航情報を発着APIから取得する。&lt;br&gt; 取得した情報をもとに各種の業務的判定処理を行い、判定結果および取得した情報を返却する。  # 2. 処理概要 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br&gt; ※ エラー情報には、エラーコードごとにエラー発生項目が含まれる。  1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてcookie、アクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。  1. リクエスト項目をもとにAltea Web Service(DCSLST_GetPassengerList)を呼び出し、フライトの空席待ち人数を取得する。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス400を返却する。  1. フライトの情報をもとに、Altea Web Service(DCSLST_GetCheckInSummaryFigures)を呼び出し、Onload Statusを取得する。&lt;br&gt; レスポンスがエラーの場合、HTTPステータス500を返却する。&lt;br&gt; Onload StatusがFinalizedの場合、空席待ちが終了しているものとしてHTTPステータス400を返却する。&lt;br&gt;  1. フライトの情報をもとに、発着APIを呼び出し、最新運航情報を取得する。&lt;br&gt; レスポンスがエラー、もしくは、取得結果が0件の場合、HTTPステータス500を返却する。 欠航の場合、空席待ちが終了しているものとしてHTTPステータス400を返却する。&lt;br&gt;  1. HTTPステータス200を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public travelersGetStandbyTravelersPost(
    generated?: PostTravelersStandByTravelersRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PostTravelersStandByTravelersResponse>;
  public travelersGetStandbyTravelersPost(
    generated?: PostTravelersStandByTravelersRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PostTravelersStandByTravelersResponse>>;
  public travelersGetStandbyTravelersPost(
    generated?: PostTravelersStandByTravelersRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PostTravelersStandByTravelersResponse>>;
  public travelersGetStandbyTravelersPost(
    generated?: PostTravelersStandByTravelersRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/travelers/get-standby-travelers`;
    return this.httpClient.request<PostTravelersStandByTravelersResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
